import $ from 'jquery';
import { getStatePure, modifyState } from '~src/state';

export const updatePageNumbers = async () => {
  $('.editor-sidebar-slides-pagination').each((index, element) => {
    $(element).text(index + 1);
  });

  $('#editor-sidebar-pages')
    .children()
    .each((index, element) => {
      $(element).attr('data-page-index', index);
      $(element).attr('id', index);
    });

  const pages = getStatePure('pages');
  // Create new page objects with updated order to avoid mutating the original
  const sortedPages = pages.map((page, index) => ({
    ...page,
    order: index,
  }));
  await modifyState('pages', sortedPages);
};
